import OptionsModalButton from './OptionsModalButton';
import { hooks, NewDateOptions } from '@eventespresso/edtr-services';
import { useConfig } from '@eventespresso/services';

const NewDateButton: React.FC = () => {
	const { isCaffeinated } = useConfig();
    const newDateOptions = <NewDateOptions>
        {(fills) => {
            if (fills.length > 1) {
                return <OptionsModalButton>{fills}</OptionsModalButton>;
            }
            return <>{fills}</>;
        }}
    </NewDateOptions>;
	return isCaffeinated
        ? hooks.applyFilters('eventEditor.addNewDate.button', newDateOptions)
	    : null;
};

export default NewDateButton;
